import React, { useState } from 'react';
import MealDetails from 'components/meal-content/meal-details';
import { Button, ToastMessage } from '@cokitchen/cokitchen-components';
import useMealContext from 'contexts/meal.context';
import { SuccessModal } from 'components/base/success-modal';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';
import { isEqual } from 'lodash';
import { CreateMealType } from 'utils/types';

const EditMealDetails = () => {
  const { formData, meal, resetForm } = useMealContext();
  const [showSuccess, setShowSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const updateBrandDetails = async () => {
    // eslint-disable-next-line
    const { brand_id, base_meal_id, ...mealData } = formData;

    setLoading(true);
    const payload: any = {
      meal_id: meal?.id,
      base_meal_id: base_meal_id[0]
    };
    for (let i = 0; i < Object.keys(mealData).length; i++) {
      const key = Object.keys(mealData)[i] as keyof Omit<
        CreateMealType,
        'brand_id' | 'base_meal_id'
      >;
      if (meal[key] === null && mealData[key] === '') continue;
      if (meal[key] === undefined) continue;
      if (!isEqual(mealData[key], meal[key])) {
        payload[key] = mealData[key];
      }
    }
    const mealPayload = Object.keys(payload).reduce((object: any, key) => {
      if (key !== 'meal_category_id') {
        if (key === 'images') {
          object[key] = payload[key].filter((url: string) => Boolean(url));
        } else {
          object[key] = payload[key];
        }
      }
      return object;
    }, {});
    try {
      const res = await apiService.put('marketing/meal-new', {
        data: {
          ...mealPayload
          //base_meal_id: mealData.base_meal_id[0]
        }
      });
      if (res?.data) {
        setShowSuccess(true);
      }
    } catch (error: any) {
      toast(<ToastMessage type='error' message={error?.response?.data?.message} />);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div>
      <MealDetails />

      <div className='flex justify-end gap-6 mt-16'>
        <Button color='primary' className='text-sm' small variant='link' onClick={resetForm}>
          Undo Changes
        </Button>
        <Button
          loading={loading}
          className='text-sm max-w-[150px]'
          onClick={updateBrandDetails}
          color='primary'
          small
          variant='block'>
          Confirm
        </Button>
      </div>

      <SuccessModal onClose={() => setShowSuccess(false)} show={showSuccess}>
        Meal updated successfully
      </SuccessModal>
    </div>
  );
};

export default EditMealDetails;
